<template>
  <div class="setting-items">
    <div class="flex h-[50px] items-center">
      <div class="flex w-1/3 items-center">
        <el-icon
          :size="12"
          style="margin-right: 5px"
          class="pointer-cursor handle"
        >
          <img
            width="12"
            height="12"
            src="@/assets/images/svg/grip.svg"
            alt="grip"
          />
        </el-icon>
        <p class="item-name">
          {{ PaymentMethodTypeToTranslatedString[formData.id] }}
        </p>
      </div>
      <div class="flex w-1/3 items-center gap-2">
        <SButton
          type="button"
          class="flex-1"
          :id="PaymentMethodTypeToTranslatedString[formData.id]"
          :variant="formData.used ? 'default' : 'outline'"
          @click="toggleStatus(true)"
          @touchstart="toggleStatus(true)"
        >
          {{ $t("button.enabled") }}
        </SButton>
        <SButton
          type="button"
          class="flex-1"
          :variant="!formData.used ? 'default' : 'outline'"
          @click="toggleStatus(false)"
          @touchstart="toggleStatus(false)"
        >
          {{ $t("button.disabled") }}
        </SButton>
      </div>
      <div class="flex w-1/3 items-center pl-2">
        <div class="flex w-full items-center">
          <div
            v-if="
              typeof formData.terminal === 'string' ||
              typeof formData.terminal === 'undefined'
            "
            class="flex-1"
          >
            <div style="position: relative" class="w-full">
              <select-card-reader
                v-model="formData.terminal"
                :disabled="!isUsed"
                @do-parent-action="checkSelectedTerminal"
              />
              <div class="terminal-warning" v-if="isUsed && !formData.terminal">
                <p>
                  {{ $t("error.no-selected-terminal") }}
                </p>
              </div>
            </div>
          </div>
          <div class="flex w-1/5 items-center justify-center">
            <div v-if="isUsed && formData.terminal">
              <p v-if="terminalConnection === TerminalConnectivity.Loading">
                <span class="spinner"></span>
              </p>
              <p v-if="terminalConnection === TerminalConnectivity.Connected">
                <span class="connected-terminal"></span>
              </p>
              <p
                v-if="terminalConnection === TerminalConnectivity.Disconnected"
              >
                <span class="disconnected-terminal"></span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  checkTerminalConnectivity,
  TerminalConnectivity,
} from "@/utils/vue-helpers/common";
import { PaymentMethodTypeToTranslatedString } from "@/utils/vue-helpers/pos-config";
import { SButton } from "@smeetz/ui-core";
import { computed, defineComponent, ref } from "vue";

export default defineComponent({
  name: "SettingsItem",
  components: { SButton },
  props: {
    settingInfo: {
      required: true,
      type: Object,
    },
  },
  setup(props) {
    const terminalConnection = ref<TerminalConnectivity | null>(null);
    const formData = computed(() => {
      return props.settingInfo;
    });

    const toggleStatus = (status: boolean) => {
      formData.value.used = status;
    };

    const isUsed = computed(() => {
      return formData.value.used;
    });

    // Function to check selected terminal connectivity
    async function checkSelectedTerminal() {
      // Lets check terminal connectivity if there is any
      const terminalId = formData.value.terminal;
      if (terminalId) {
        terminalConnection.value = TerminalConnectivity.Loading;
        terminalConnection.value = await checkTerminalConnectivity(terminalId);
      }
    }

    return {
      formData,
      toggleStatus,
      isUsed,
      PaymentMethodTypeToTranslatedString,
      checkSelectedTerminal,
      terminalConnection,
      TerminalConnectivity,
    };
  },
  async mounted() {
    if (this.formData.terminal) {
      await this.checkSelectedTerminal();
    }
  },
});
</script>

<style lang="scss">
@use "@/styles/variables.scss" as *;

.setting-items {
  .item-name {
    line-height: 22px;
    letter-spacing: 0px;
    font-weight: 400;
    font-style: normal;
    font-size: 16px;
    text-align: left;
    white-space: pre-wrap;
  }

  .terminal-warning {
    position: absolute;
    width: 100%;
    left: 50%;
    top: calc(100% + 10px);
    transform: translate(-50%, 0);
    padding: 5px;
    font-size: 12px;
    font-weight: 700;
    line-height: normal;
    text-align: center;
    color: #f44336;
    border: 1px solid #f44336;
    border-radius: 5px;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
    word-break: normal;
    overflow-wrap: break-word;
  }

  .spinner {
    display: inline-block;
    width: 20px;
    height: 20px;
    border: 2px solid #ccc;
    border-radius: 50%;
    border-top-color: #333;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .connected-terminal {
    display: inline-block;
    width: 20px;
    height: 20px;
    border: 2px solid green;
    background-color: green;
    border-radius: 50%;
  }

  .disconnected-terminal {
    display: inline-block;
    width: 20px;
    height: 20px;
    border: 2px solid red;
    background-color: red;
    border-radius: 50%;
  }
}
</style>
